import Login from '../Login';
import Menu from "../Menu";
import Guid from "../Login/Guid";
import Item from '../Menu/NavBar/Item';
import ResetPass from '../Login/ResetPass';
import Preferencias from '../Preferencias';
import ConfigUser from '../ConfigUser';
import CambiarPassword from '../CambiarPassword';
import TerminosAdmin from '../TerminosAdmin';
import TerminoAdminItem from '../TerminosAdmin/item';
import TerminoAdminUser from '../TerminosAdmin/user';
import Auditoria from '../AuditoriaAdmin/'
import AuditoriaDetalle from '../AuditoriaAdmin/indexDetalle'
import AuditoriaPrint from '../AuditoriaAdmin/components/AuditoriaPrint'
import Documentos from '../Documentos'
import Notificaciones from '../Notificaciones';
import Usuario from '../Usuario/index';
import Roles from '../Role/index';
import Role from '../Role/indexRole';
import ConsultaNotificaciones from '../Notificaciones/components/ConsultaNotificaciones';
import Terminos from '../Terminos';
import UsuariosAdmin from '../UsuariosAdmin';
import UsuariosAdminItem from '../UsuariosAdmin/components/UsuarioAdminItem';
import ClientesCC from '../ClientesCC/index';
import Instituciones from '../Instituciones/index';
import Institucion from '../Instituciones/indexInstitucion';
import Insumos from '../Insumos/index';
import Insumo from '../Insumos/indexInsumo';
import PlanCuidadoSearch from '../PlanCuidadoSearch'
import AssistanceProgram from '../AssistanceProgram';
import AssistanceProgramCreation from '../AssistanceProgramCreation';
import PlanCuidadoCreation from '../PlanCuidadoCreation';
import ProveedorDistribuidorSearch from '../ProveedorDistribuidorSearch'
import ProveedorDistribuidorCreation from '../ProveedorDistribuidorCreation'
import FrecuenciaDistribuidorSearch from '../FrecuenciaDistribuidorSearch'
import FrecuenciaDistribuidorCreation from '../FrecuenciaDistribuidorCreation'
import PacienteProbableSearch from '../PacienteProbable';
import { Navigate } from "react-router-dom";
import PlanCuidadoValidar from '../PlanCuidadoValidate';
import PlanCuidadoPreview from '../PlanCuidadoPreview';
import GestionCrediticia from '../GestionCrediticia';
import Prorroga from '../Prorroga';
import GestionLogistica from '../GestionLogistica';
import DetalleGestionLogistica from '../GestionLogistica/indexDetalle'
import PacienteProbableCreation from '../PacienteProbableCreation';
import ResumenIngresoCreation from '../ResumenIngresoCreation';
import RiEvMedico from '../RI-EV-MedicoCreation';
import RiEvMedicoCons from '../RI-EV-MedicoSearch';
import MisTareas from '../MisTareas';
import MisTareasDocuments from '../MisTareas/MisTareasDocuments';
import ContratosSearch from '../ContratosSearch';
import ContratoCreation from '../ContratosCreation';
import InsumoValidar from '../InsumoValidate';
import InsumoValidatePreview from '../InsumoValidatePreview';
import GestionPrecio from '../GestionPrecio';
import GestionPrecioMasivo from '../GestionPrecioMasivo';
import GestionPrecioMasivoDetalle from '../GestionPrecioMasivo/indexDetalle';
import DocumentsSearch from '../DocumentsSearch';
import DocumentsDetail from '../DocumentsDetail';
import Traditum from '../Traditum';
import TraditumDetalle from '../TraditumDetalle';
import RequisitoClientes from '../RequisitoClientes';
import RequisitoClienteCreation from '../RequisitoClientesCreation';
import ResumenIngresoDetalle from '../ResumenIngresoDetalle';
import AdminBloqueo from '../AdminBloqueo';
import JustificacionBloqueo from '../AdminBloqueo/indexJustificacion';
import RIValidation from '../RIValidationSearch';
import RIValidationDetalle from '../RIValidation';
import RIValidationIndicacion from '../RIValidationIndicacion';
import RICambioIndicacion from '../RIValidationCambioIndicacion';
import RIConfirmarEquipoDetalle from '../RIValidationConfirmarEquipo';
import RICambioProgramaDetalle from '../RIValidationCambioPrograma';
import RIAsignacionDetalle from '../RIAsignacion';
import Reclamos from '../Reclamos';
import Capas from '../Capas';
import ReclamoCreation from '../ReclamoCreation';
import CapaCreation from '../CapaCreation';
import AdminHonorarios from '../AdminHonorarios';
import HonorarioCreation from '../AdminHonorarioCreation';
import Tramos from '../Tramos';
import TramoCreation from '../TramoCreation';
import GestionAsistencialCreation from '../GestionAsistencialCreation';
import GestionAsistencial from '../GestionAsistencial';
import AdminIndicacion from '../AdminIndicacion';
import { AdminIndicacionDetalle } from '../AdminIndicacion/components/AdminIndicacionDetalle';
import EnvioCreation from '../EnvioCreation';
import GestionEnvios from '../GestionEnvios';
import AdminConexiones from '../AdminConexiones';
import AdminConexionesDetalle from '../AdminConexionDetalle';
import GestionProfesionales from '../GestionProfesionales';
import GestionProfesionalCreation from '../GestionProfesionalCreation';
import MonitoreoProfesionales from '../MonitoreoProfesionales';
import MonitoreoProfesionalesCreation from '../MonitoreoProfesionalesCreation';
import AdminSugerenciasMonitoreo from '../AdminSugerenciasMonitoreo';
import CierreVentas from '../CierreVentas';
import GenerarMinuta from '../GenerarMinuta';
import { GenerarMinutaDetalle } from '../GenerarMinuta/components/GenerarMinutaDetalle';
import ImprimirMinuta from '../ImprimirMinuta';
import { ImprimirMinutaDetalle } from '../ImprimirMinuta/components/ImprimirMinutaDetalle';
import ListarMinuta from '../ListarMinuta';
import GestionPeriodos from '../GestionPeriodos';
import { ListarMinutaDetalle } from '../ListarMinuta/components/ListarMinutaDetalle';
import JustificarMinuta from '../JustificarMinuta';
import { JustificarMinutaDetalle } from '../JustificarMinuta/components/JustificarMinutaDetalle';
import PrecioControl from '../PrecioControl';
import AutCambioPrecio from '../AutCambioPrecio';
import IndexPrecioControlDetalle from '../PrecioControlDetalle';
import MisVisitas from '../MisVisitas';
import MisVisitasContrato from '../MisVisitasContrato';
import MisVisitasCreation from '../MisVisitasCreation';
import MisVisitasNotificaciones from '../MisVisitasNotificaciones';
import ControlVisitas from '../ControlVisitas';
import ControlVisitaDetalle from '../ControlVisitasDetalle';
import ImprimirVisita from '../ImprimirVisita';
import HerramientaGeoposicion from '../HerramientaGeoposicion';
import { ResumenIngresoPrint } from '../ResumenIngresoDetalle/components/ResumenIngresoPrint';
import ReporteBOT from '../ReporteBOT';
import Conformidades from '../Conformidades';
import BuscarPaciente from '../BuscarPaciente';
import BuscarPacienteDetalle from '../BuscarPacienteDetalle';
import ConsultasGenerales from '../ConsultasGenerales';
import DocumentosSAP from '../DocumentosSAP';
import BorrarConexiones from '../BorrarConexiones';
import AdminHonorarioFidelizado from '../AdminHonorarioFidelizado';
import AdminHonorarioFidelizadoCreation from '../AdminHonorarioFidelizadoCreation';
import PreLiquidacion from '../PreLiquidacion';
import LiquidacionFinal from '../LiquidacionFinal';
import SoporteHC from '../SoporteHC';
import ReenviarMail from '../ReenviarMail';

export const publicRoutes = [
    {
        path: '/',
        element: <Login />
    },
    {
        path: '/resetpass',
        element: <ResetPass />
    },
    {
        path: '/guid',
        element: <Guid />
    },
    {
        path: '*',
        element: <Navigate to="/" replace="true" />
    }
];

export const privateRoutes = [
    {
        path: '/cambiarPassword',
        element: <CambiarPassword />
    },
    {
        path: '/preferencias',
        element: <Preferencias />
    },
    {
        path: '/configuser',
        element: <ConfigUser />
    },
    {
        path: '/usuario',
        element: <Usuario />
    },
    {
        path: '/role',
        element: <Roles />
    },
    {
        path: '/role/:roleId',
        element: <Role />
    },
    {
        path: '/usuarioadmin',
        element: <UsuariosAdmin />
    },
    {
        path: '/usuarioadmin/:usuarioId',
        element: <UsuariosAdminItem />
    },
    {
        path: '/menu',
        element: <Menu />
    },
    {
        path: '/menu/:url',
        element: <Item />
    },
    {
        path: '/documentos',
        element: <Documentos />
    },
    {
        path: '/terminos',
        element: <Terminos />
    },
    {
        path: '/termadmin',
        element: <TerminosAdmin />
    },
    {
        path: '/termadmin/:terminoId',
        element: <TerminoAdminItem />
    },
    {
        path: '/termusers/:terminoId',
        element: <TerminoAdminUser />
    },
    {
        path: '/auditoria',
        element: <Auditoria />
    },
    {
        path: '/auditoriaDetalle/:auditoriaId',
        element: <AuditoriaDetalle />
    },
    {
        path: '/auditoriaPrint/:auditoriaId',
        element: <AuditoriaPrint />
    },
    {
        path: '/notificaciones',
        element: <Notificaciones />
    },
    {
        path: '/allNotificaciones',
        element: <ConsultaNotificaciones />
    },
    {
        path: '/clientesCC',
        element: <ClientesCC />
    },
    {
        path: '/institucionAdmin',
        element: <Instituciones />
    },
    {
        path: '/institucionAdmin/:codInstitucion',
        element: <Institucion />
    },
    {
        path: '/insumoAdmin',
        element: <Insumos />
    },
    {
        path: '/insumoAdmin/:idInsumo',
        element: <Insumo />
    },
    {
        path: '/buscarPlan',
        element: <PlanCuidadoSearch />
    },
    {
        path: '/programas',
        element: <AssistanceProgram />
    },
    {
        path: '/programas/nuevoPrograma',
        element: <AssistanceProgramCreation />
    },
    {
        path: '/buscarPlan/planCuidado',
        element: <PlanCuidadoCreation />
    },
    {
        path: '/buscarProveedorDistribuidor',
        element: <ProveedorDistribuidorSearch />
    },
    {
        path: '/buscarProveedorDistribuidor/proveedorDistribuidor',
        element: <ProveedorDistribuidorCreation />
    },
    {
        path: '/buscarFrecuenciaDistribuidor',
        element: <FrecuenciaDistribuidorSearch />
    },
    {
        path: '/frecuenciaDistribuidor',
        element: <FrecuenciaDistribuidorCreation />
    },
    {
        path: '/pacienteProbable',
        element: <PacienteProbableSearch />
    },
    {
        path: '/pacienteProbableCOM',
        element: <PacienteProbableSearch />
    },
    {
        path: '/validarPlan',
        element: <PlanCuidadoValidar />
    },
    {
        path: '/validarPlan/previsualizacionPlanCuidado',
        element: <PlanCuidadoPreview />
    },
    {
        path: '/gestionCrediticia',
        element: <GestionCrediticia />
    },
    {
        path: '/gestionLogistica',
        element: <GestionLogistica />
    },
    {
        path: '/gestionLogistica/detalleGestionLogistica',
        element: <DetalleGestionLogistica />
    },
    {
        path: '/pacienteProbable/crearPacienteProbable',
        element: <PacienteProbableCreation />
    },
    {
        path: '/detalleGestionLogistica',
        element: <DetalleGestionLogistica />
    },
    {
        path: '/resumenIngreso/crearResumenIngreso',
        element: <ResumenIngresoCreation />
    },
    {
        path: '/resumenIngreso/detalle',
        element: <ResumenIngresoDetalle />
    },
    {
        path: '/resumenIngreso/print',
        element: <ResumenIngresoPrint />
    },
    {
        path: '/rievMedico',
        element: <RiEvMedico />
    },
    {
        path: '/rievMedicoCons',
        element: <RiEvMedicoCons />
    },
    {
        path: '/misTareas',
        element: <MisTareas />
    },
    {
        path: '/misTareas/documentos',
        element: <MisTareasDocuments />
    },
    {
        path: '/contratos',
        element: <ContratosSearch />
    },
    {
        path: '/contratos/crearContrato',
        element: <ContratoCreation />
    },
    {
        path: '/validarInsumo',
        element: <InsumoValidar />
    },
    {
        path: '/validarInsumo/insumo',
        element: <InsumoValidatePreview />
    },
    {
        path: '/gestionPrecio',
        element: <GestionPrecio />
    },
    {
        path: '/gestionPrecioMasivo',
        element: <GestionPrecioMasivo />
    },
    {
        path: '/gestionPrecioMasivo/precioMasivo',
        element: <GestionPrecioMasivoDetalle />
    },
    {
        path: '/prorrogas',
        element: <Prorroga />
    },
    {
        path: '/consultadoc',
        element: <DocumentsSearch />
    },
    {
        path: '/consultadoc/detalle',
        element: <DocumentsDetail />
    },
    {
        path: '/traditum/',
        element: <Traditum />
    },
    {
        path: '/traditum/detalleSolicitud',
        element: <TraditumDetalle />
    },
    {
        path: '/requisitosClientes',
        element: <RequisitoClientes />
    },
    {
        path: '/requisitosClientes/detalleCliente',
        element: <RequisitoClienteCreation />
    },
    {
        path: '/adminBloqueo',
        element: <AdminBloqueo />
    },
    {
        path: '/adminBloqueoEM',
        element: <AdminBloqueo />
    },
    {
        path: '/adminBloqueoHC',
        element: <AdminBloqueo />
    },
    {
        path: '/adminBloqueo/justificacionBloqueo',
        element: <JustificacionBloqueo />
    },
    {
        path: '/adminBloqueoEM/justificacionBloqueo',
        element: <JustificacionBloqueo />
    },
    {
        path: '/adminBloqueoHC/justificacionBloqueo',
        element: <JustificacionBloqueo />
    },
    {
        path: '/asignacionValidacionResumenIngreso',
        element: <RIValidation />
    },
    {
        path: '/asignacionValidacionResumenIngreso/validar',
        element: <RIValidationDetalle />
    },
    {
        path: '/asignacionValidacionResumenIngreso/asignar',
        element: <RIAsignacionDetalle />
    },
    {
        path: '/asignacionValidacionResumenIngreso/ingresoIndicacion',
        element: <RIValidationIndicacion />
    },
    {
        path: '/asignacionValidacionResumenIngreso/cambioIndicacion',
        element: <RICambioIndicacion />
    },
    {
        path: '/asignacionValidacionResumenIngreso/confirmarEquipo',
        element: <RIConfirmarEquipoDetalle />
    },
    {
        path: '/asignacionValidacionResumenIngreso/cambioPrograma',
        element: <RICambioProgramaDetalle />
    },
    {
        path: 'calidad/:tipoGestion',
        element: <Reclamos />
    },
    {
        path: 'calidad/capas',
        element: <Capas />
    },
    {
        path: '/calidad/crear/:tipoGestion',
        element: <ReclamoCreation />
    },
    {
        path: '/calidad/crear/capa',
        element: <CapaCreation />
    },
    {
        path: 'honorarios/adminHonorarios',
        element: <AdminHonorarios />
    },
    {
        path: '/honorarios/nuevoHonorario',
        element: <HonorarioCreation />
    },
    {
        path: '/honorarios/adminTramos',
        element: <Tramos />
    },
    {
        path: '/honorarios/nuevoTramo',
        element: <TramoCreation />
    },
    {
        path: '/asistencial/gestionAsistencial',
        element: <GestionAsistencial />
    },
    {
        path: '/asistencial/gestionAsistencial/detalle',
        element: <GestionAsistencialCreation />
    },
    {
        path: '/adminIndicacion',
        element: <AdminIndicacion />
    },
    {
        path: '/adminIndicacionCOM',
        element: <AdminIndicacion />
    },
    {
        path: '/adminIndicacion/detalle',
        element: <AdminIndicacionDetalle />
    },
    {
        path: '/adminIndicacionCOM/detalle',
        element: <AdminIndicacionDetalle />
    },
    {
        path: '/envio/nuevoEnvio',
        element: <EnvioCreation />
    },
    {
        path: '/asistencial/gestionEnvios',
        element: <GestionEnvios />
    },
    {
        path: '/asistencial/adminConexiones',
        element: <AdminConexiones />
    },
    {
        path: '/asistencial/adminConexiones/detalle',
        element: <AdminConexionesDetalle />
    },
    {
        path: '/asistencial/gestionProfesionales',
        element: <GestionProfesionales />
    },
    {
        path: '/asistencial/gestionProfesionales/altaProfesional',
        element: <GestionProfesionalCreation />
    },
    {
        path: '/asistencial/monitoreoProfesionales',
        element: <MonitoreoProfesionales />
    },
    {
        path: '/asistencial/monitoreoProfesionales/modificacionProfesional',
        element: <MonitoreoProfesionalesCreation />
    },
    {
        path: '/asistencial/adminSugerencias',
        element: <AdminSugerenciasMonitoreo />
    },
    {
        path: '/cierreVentas/cierreDeVentas',
        element: <CierreVentas />
    },
    {
        path: '/generarMinuta',
        element: <GenerarMinuta />
    },
    {
        path: '/generarMinuta/detalle',
        element: <GenerarMinutaDetalle />
    },
    {
        path: '/imprimirMinuta',
        element: <ImprimirMinuta />
    },
    {
        path: '/imprimirMinuta/detalle',
        element: <ImprimirMinutaDetalle />
    },
    {
        path: '/listarMinuta',
        element: <ListarMinuta />
    },
    {
        path: '/cierreVentas/gestionPeriodos',
        element: <GestionPeriodos />
    },
    {
        path: '/listarMinuta/detalle',
        element: <ListarMinutaDetalle />
    },
    {
        path: '/justificarMinuta',
        element: <JustificarMinuta />
    },
    {
        path: '/justificarMinuta/detalle',
        element: <JustificarMinutaDetalle />
    },
    {
        path: '/autorizacionPrecioControl',
        element: <PrecioControl />
    },
    {
        path: '/autorizacionPrecioControl/detalle/:id',
        element: <IndexPrecioControlDetalle />
    },
    {
        path: '/autorizacionCambioPrecio/autorizacionCambioPrecio',
        element: <AutCambioPrecio />
    },
    {
        path: '/misVisitas',
        element: <MisVisitas />
    },
    {
        path: '/misVisitas/visitasContrato',
        element: <MisVisitasContrato />
    },
    {
        path: '/misVisitas/nuevaVisita',
        element: <MisVisitasCreation />
    },
    {
        path: '/misVisitas/notificaciones',
        element: <MisVisitasNotificaciones />
    },
    {
        path: '/controlVisitas',
        element: <ControlVisitas />
    },
    {
        path: '/controlVisitas/detalle',
        element: <ControlVisitaDetalle />
    },
    {
        path: '/imprimirVisita',
        element: <ImprimirVisita />
    },
    {
        path: '/geoposicionamientoPacientes',
        element: <HerramientaGeoposicion />
    },
    {
        path: '/reporteBOT',
        element: <ReporteBOT />
    },
    {
        path: '/conformidades',
        element: <Conformidades />
    },
    {
        path: '/buscarPaciente',
        element: <BuscarPaciente />
    },
    {
        path: '/buscarPaciente/detalle/:idPaciente',
        element: <BuscarPacienteDetalle />
    },
    {
        path: '/consultas/generales',
        element: <ConsultasGenerales />
    },
    {
        path: 'consultas/documentosSAP',
        element: <DocumentosSAP />
    },
    {
        path: 'administracion/borrarConexiones',
        element: <BorrarConexiones />
    },
    {
        path: '/honorarios/fidelizados',
        element: <AdminHonorarioFidelizado />
    },
    {
        path: '/honorarios/fidelizados/nuevo',
        element: <AdminHonorarioFidelizadoCreation />
    },
    {
        path: '/honorarios/preLiquidacion',
        element: <PreLiquidacion />
    },
    {
        path: '/honorarios/liquidacionFinal',
        element: <LiquidacionFinal />
    },
    {
        path: '/administracion/soporteHC',
        element: <SoporteHC />
    },
    {
        path: '/honorarios/rvMail',
        element: <ReenviarMail />
    },
];